export const TaskServiceConstants = {
  DefaultRetryAttempts: 10,
  MaximumRetyAttempts: 10
};